var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"xs":24,"sm":24,"md":18}},[_c('el-card',[_c('user-edit-self-form')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }